import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UsersService, PasswordReset } from '../../Api_Module';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'crg-user-password',
  templateUrl: './user-password.component.html',
  styleUrls: ['./user-password.component.scss']
})
export class UserPasswordComponent implements OnInit {
    token: string;
    password: string;
    confirmPassword: string;
    model: PasswordReset;
    loading: boolean;

    constructor(private activatedRoute: ActivatedRoute, private usersService: UsersService, private router: Router, private toastr: ToastrService) { }

    ngOnInit() {
        this.model = {};
        this.activatedRoute.queryParams.subscribe(params => {

            this.token = params['token'];
        });
    }

    handleReset() {
        if (this.model.password != this.model.confirmPassword) {
            this.toastr.error('Passwords do not match!');
            return;
        }
        this.loading = true;
        this.model.token = this.token;
        this.usersService.reset(this.model).subscribe(resp => {
            this.toastr.info('Password reset successfully');
            this.router.navigate(['/login'])
        }, err => {
                this.loading = false;
        });

    }

}
